export default "__VITE_ASSET__POoW3MyQ__"